(function(){
    'use strict'; 
    angular.module('Directives').directive('addressDetails', addressDetails);
    addressDetails.$inject = []; 

    /**
     * @directive   addressDetailsDirective
     * @description Generate an address display panel
     * 
     * @param       { string } header - Panel header text.
     * @param       { Object } addressData - Holds the address data.
     */
    function addressDetails(){
        return {
            restrict    : 'E', 
            templateUrl : '/templates/directives/components/shipment-details/address-details.html', 
            scope       : {
                header      :'=',
                addressData : '='
            }, 
            link        : AddressDetailsDirectiveLink
        }

        function AddressDetailsDirectiveLink($scope, $elems, $attrs){
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/shipment-details/addressDetails.js